module.exports = __webpack_public_path__ + "static/media/Statues JNKVV 1964_compressed.a63a9367.pdf";